import PopupFrame from '@/component/popups/ui-1';
import { useTranslation } from 'react-i18next';
import { InputText } from './components/InputText';
import { InputPassword } from './components/InputPassword';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginWithOtp, loginWithPassword, requestOtp, verifyOtp } from '@/Redux/futures/account/actions';
import { handleNumericInput } from '@/helper/helper';
import Buttons from '@/component/popups/Buttons';
import { setReduxDataTypeIntroTour } from '@/Redux/futures/home/actions';
import { toast } from 'react-toastify';
import { getIsdnNoNationalCode, Toast } from '@/utils/helper';
import { setCookieChangePw } from '@/utils/cookie';
import { KEY_LOCAL_TOUR_COMPLETE, KEY_LOCAL_TYPE_USER, TYPE_USER } from '@/helper/const';
import { useLocation, useNavigate } from 'react-router';
import { useLoginModal } from '@/contexts/LoginModalContext';
import PATH from '@/config/PATH';

export default function Login() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate()
	const location = useLocation();
	const [typeLogin, setTypeLogin] = useState(true)
	const { isOpen, closeLogin, handleLoginSuccess } = useLoginModal();
	const [phoneNumber, setPhoneNumber] = useState('');
	const [password, setPassword] = useState('');
	const [otp, setOtp] = useState("");
	const [statusInput, setStatusInput] = useState({
		phoneNumber: '',
		password: '',
		otp: '',
	});
	const [errorMessages, setErrorMessages] = useState({
		phoneNumber: '',
		password: '',
		otp: '',
	});
	const [messageError, setMessageError] = useState('');
	const [isLoadingBtn, setIsLoadingBtn] = useState(false);
	const [countdown, setCountdown] = useState(0);
	const inputRefPhoneNumber = useRef(null);
	const inputRefPassWord = useRef(null);
	const inputRefOTP = useRef(null);
	const countdownIntervalRef = useRef(null);

	useEffect(() => {
		if (!isOpen) {
			clearInterval(countdownIntervalRef.current);
			setCountdown(0);
		}
	}, [isOpen]);

	const afterLoginPassword = (dataSuccess, isLoading, dataError = null) => {
		if (!isLoading) {
			if (dataSuccess?.data?.isNewUser) {
				setCookieChangePw();
			}
			if (dataSuccess?.data?.type_user) {
				localStorage.setItem(KEY_LOCAL_TYPE_USER, dataSuccess?.data?.type_user);
				const tourHistoryKey = `TOUR_SHOWN_${phoneNumber}`;
				const tourHistory = JSON.parse(localStorage.getItem(tourHistoryKey) || '{}');

				const userTypeKey = dataSuccess?.data?.type_user.toString();

				const hasShownTourForThisUserType = tourHistory[userTypeKey];
				const isPU4EligibleType = [
					TYPE_USER.newNoPackage,
					TYPE_USER.newPackage,
					TYPE_USER.firstLoginAfterRegistered7Days,
					TYPE_USER.firstLoginWithinRegistered2To6Days,
				].includes(+dataSuccess?.data?.type_user);
				if (
					Object.values(TYPE_USER).includes(dataSuccess?.data?.type_user) &&
					dataSuccess?.data?.type_user !== TYPE_USER.general &&
					!hasShownTourForThisUserType
				) {
					dispatch(
						setReduxDataTypeIntroTour({
							typeActive: +dataSuccess?.data?.type_user,
							step: 0,
						})
					);
					tourHistory[userTypeKey] = true;
					localStorage.setItem(tourHistoryKey, JSON.stringify(tourHistory));
				} else if (isPU4EligibleType) {
					dispatch(
						setReduxDataTypeIntroTour({
							typeActive: +dataSuccess?.data?.type_user,
							step: 0,
						})
					);
				} else {
					localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
					dispatch(
						setReduxDataTypeIntroTour({
							typeActive: TYPE_USER.general,
							step: -1,
						})
					);
				}
			}

			if (dataError) {
				setMessageError(dataError.errorMessage);
				toast.dismiss();
				Toast.error(dataError.errorMessage, {
					autoClose: 4000,
				});
			} else {
				setStatusInput({
					phoneNumber: "",
					password: "",
				});
				setPassword("");
				setPhoneNumber("");
				if (location?.state?.from?.state?.from === 'minigame') {
					closeLogin();
					navigate(location?.state?.from?.state?.pathlastname);
				} else {
					// navigate(PATH.HOME, { replace: true });
					handleLoginSuccess(dataSuccess);
				}
			}
		}
	};

	const afterRequestOtp = (data, isLoading) => {
		if (data) {
			if (!data?.success) {
				return;
			}
			const timerRequest = 180; //3 phút
			setCountdown(timerRequest);
			clearInterval(countdownIntervalRef.current);
			countdownIntervalRef.current = setInterval(() => {
				setCountdown((prev) => {
					if (prev === 1 || prev < 1) {
						clearInterval(countdownIntervalRef.current);
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
		}
	};

	const handleSubmitPhoneNumber = async () => {
		if (isLoadingBtn) return;
		const phoneEmpty = !phoneNumber || phoneNumber.trim() === '';
		const phoneInvalid = !phoneEmpty && !isValidPhoneNumber(phoneNumber);
		const passEmpty = !password || password.trim() === '';

		if (phoneEmpty || phoneInvalid || passEmpty) {
			setStatusInput({
				phoneNumber: (phoneEmpty || phoneInvalid) ? 'error' : '',
				password: passEmpty ? 'error' : '',
			});
			setErrorMessages({
				phoneNumber: phoneEmpty
					? t("modal.modal_login.please_your_mytel_number")
					: phoneInvalid
						? t("modal.modal_login.please_your_mytel_number")
						: '',
				password: passEmpty ? t("modal.modal_login.please_your_mytel_password") : '',
			});
			if (phoneEmpty || phoneInvalid) inputRefPhoneNumber.current?.focus();
			else inputRefPassWord.current?.focus();
			return;
		}

		setMessageError('');
		setErrorMessages({ phoneNumber: '', password: '', otp: '' });
		setIsLoadingBtn(true);
		const body = {
			isdn: phoneNumber,
			password: password,
			callback: afterLoginPassword,
		};
		await dispatch(loginWithPassword(body));
		setIsLoadingBtn(false);
	};

	const afterLoginOtp = (dataSuccess, isLoading, dataError = null) => {
		if (!isLoading) {
			if (dataSuccess?.data?.isNewUser) {
				setCookieChangePw();
			}

			if (dataSuccess?.data?.type_user) {
				localStorage.setItem(KEY_LOCAL_TYPE_USER, dataSuccess?.data?.type_user);
				const tourHistoryKey = `TOUR_SHOWN_${phoneNumber}`;
				const tourHistory = JSON.parse(localStorage.getItem(tourHistoryKey) || '{}');

				const userTypeKey = dataSuccess?.data?.type_user.toString();

				const hasShownTourForThisUserType = tourHistory[userTypeKey];
				const isPU4EligibleType = [
					TYPE_USER.newNoPackage,
					TYPE_USER.newPackage,
					TYPE_USER.firstLoginAfterRegistered7Days,
					TYPE_USER.firstLoginWithinRegistered2To6Days,
				].includes(+dataSuccess?.data?.type_user);
				if (
					Object.values(TYPE_USER).includes(dataSuccess?.data?.type_user) &&
					dataSuccess?.data?.type_user !== TYPE_USER.general &&
					!hasShownTourForThisUserType
				) {
					dispatch(
						setReduxDataTypeIntroTour({
							typeActive: +dataSuccess?.data?.type_user,
							step: 0,
						})
					);
					tourHistory[userTypeKey] = true;
					localStorage.setItem(tourHistoryKey, JSON.stringify(tourHistory));
				} else if (isPU4EligibleType) {
					dispatch(
						setReduxDataTypeIntroTour({
							typeActive: +dataSuccess?.data?.type_user,
							step: 0,
						})
					);
				} else {
					localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
					dispatch(
						setReduxDataTypeIntroTour({
							typeActive: TYPE_USER.general,
							step: -1,
						})
					);
				}
			}

			setStatusInput({
				phoneNumber: "",
				password: "",
			});
			setPassword("");
			setPhoneNumber("");
			setOtp("");
			clearInterval(countdownIntervalRef.current);
			setCountdown(0);
			closeLogin();
			if (location?.state?.from?.state?.from === 'minigame') {
				closeLogin();
				navigate(location?.state?.from?.state?.pathlastname);
			} else {
				// navigate(PATH.HOME, { replace: true });
				handleLoginSuccess(dataSuccess);
			}
		}
	};

	const afterverifyOtp = (data, isLoading, dataError) => {
		if (!isLoading) {
			if (dataError) {
				setMessageError(dataError.errorMessage);
				toast.dismiss();
				Toast.error(dataError.errorMessage, {
					autoClose: 4000,
				});
			} else {
				const body = {
					isdnOtp: phoneNumber,
					callback: afterLoginOtp,
				};
				dispatch(loginWithOtp(body));
			}
		}
	};

	const handleSendOTP = async () => {
		if (isLoadingBtn) return;
		const phoneEmpty = !phoneNumber || phoneNumber.trim() === '';
		const phoneInvalid = !phoneEmpty && !isValidPhoneNumber(phoneNumber);

		if (phoneEmpty || phoneInvalid) {
			setStatusInput((prev) => ({
				...prev,
				phoneNumber: 'error',
			}));
			setErrorMessages((prev) => ({
				...prev,
				phoneNumber: t("modal.modal_login.please_your_mytel_number"),
			}));
			inputRefPhoneNumber.current?.focus();
			return;
		}

		if (countdown) {
			return null;
		}

		setMessageError("");
		setErrorMessages((prev) => ({ ...prev, phoneNumber: '' }));
		const body = {
			isdn: phoneNumber,
			callback: afterRequestOtp,
		};
		setIsLoadingBtn(true);
		await dispatch(requestOtp(body));
		setIsLoadingBtn(false);
	};

	const handleSubmitOTP = async () => {
		if (isLoadingBtn) return;
		const phoneEmpty = !phoneNumber || phoneNumber.trim() === '';
		const phoneInvalid = !phoneEmpty && !isValidPhoneNumber(phoneNumber);
		const otpEmpty = !otp || otp.trim() === "";

		if (phoneEmpty || phoneInvalid || otpEmpty) {
			setStatusInput((prev) => ({
				...prev,
				phoneNumber: (phoneEmpty || phoneInvalid) ? 'error' : '',
				otp: otpEmpty ? 'error' : '',
			}));
			setErrorMessages((prev) => ({
				...prev,
				phoneNumber: phoneEmpty
					? t("modal.modal_login.please_your_mytel_number")
					: phoneInvalid
						? t("modal.modal_login.please_your_mytel_number")
						: '',
				otp: otpEmpty ? t("modal.modal_login.please_your_mytel_otp") : '',
			}));
			if (phoneEmpty || phoneInvalid) inputRefPhoneNumber.current?.focus();
			else inputRefOTP.current?.focus();
			return;
		}

		setErrorMessages({ phoneNumber: '', password: '', otp: '' });
		const body = {
			isdnOtp: phoneNumber,
			otp: otp,
			callback: afterverifyOtp,
		};
		setIsLoadingBtn(2);
		await dispatch(verifyOtp(body));
		setIsLoadingBtn(false);
	};

	useEffect(() => { // tự động submit OTP khi đủ 6 ký tự và không đang loading
		if (!typeLogin && otp.length === 6 && !isLoadingBtn) {
			handleSubmitOTP();
		}
	}, [otp]);

	const isValidPhoneNumber = (value) => {
		const noNationalCode = getIsdnNoNationalCode(value);
		return /^\d{9,10}$/.test(noNationalCode);
	};

	const handlePhoneNumberChange = (e) => {
		const numericValue = handleNumericInput(e.target.value);
		setPhoneNumber(numericValue);

		if (numericValue.length === 0) {
			setStatusInput((prev) => ({ ...prev, phoneNumber: '' }));
			setErrorMessages((prev) => ({ ...prev, phoneNumber: '' }));
		} else if (numericValue.length >= 9 && !isValidPhoneNumber(numericValue)) {
			setStatusInput((prev) => ({ ...prev, phoneNumber: 'error' }));
			setErrorMessages((prev) => ({ ...prev, phoneNumber: t("modal.modal_login.please_your_mytel_number") }));
		} else {
			setStatusInput((prev) => ({ ...prev, phoneNumber: '' }));
			setErrorMessages((prev) => ({ ...prev, phoneNumber: '' }));
		}
	};

	const handleLoginWith = () => {
		setTypeLogin(!typeLogin)
		setMessageError('')
		setPassword('')
		setOtp('')
		setStatusInput((prev) => ({ ...prev, password: '', otp: '' }))
		setErrorMessages((prev) => ({ ...prev, password: '', otp: '' }))
	}

	return (
		<PopupFrame
			open={isOpen}
			onOpenChange={closeLogin}
			title={t('header.login')}
		>
			<div className="flex flex-col items-start justify-center py-5">
				<InputText
					label={t("modal.modal_login.phone_number")}
					required
					placeholder={t("modal.modal_login.phone_number_placeholder")}
					value={phoneNumber}
					status={statusInput.phoneNumber}
					onChange={handlePhoneNumberChange}
					inputRef={inputRefPhoneNumber}
					errorMessage={errorMessages.phoneNumber}
					inputMode="numeric"
					pattern="[0-9]*"
				/>
				{typeLogin ?
					<InputPassword //show form login bằng SĐT khi true
						label={t("modal.modal_login.password")}
						required
						placeholder={t("modal.modal_login.password_placeholder")}
						value={password}
						status={statusInput.password}
						onChange={(e) => setPassword(e.target.value)}
						inputRef={inputRefPassWord}
						errorMessage={errorMessages.password}
						autoCapitalize="off"
					/>
					:
					<InputText //show form login bằng OTP khi false
						label={t("modal.modal_login.confirm_otp")}
						required
						placeholder={t("modal.modal_login.enter_otp")}
						value={otp}
						status={statusInput.otp}
						onChange={(e) => setOtp(e?.target?.value?.replace(/\D/g, ''))}
						inputRef={inputRefOTP}
						maxLength={6}
						errorMessage={errorMessages.otp}
						isOTP={true}
						handleSendOTP={handleSendOTP}
						countdown={countdown}
						inputMode="numeric"
						pattern="[0-9]*"
						autoCapitalize="off"
					/>
				}
				<p className="text-[rgba(161,92,7,1)] text-[12px] sm:text-[15px] mt-1">{messageError}</p>
				<div className='flex flex-col gap-5 items-center justify-center w-full px-9 sm:px-27 pt-2 sm:pt-6'>
					{typeLogin &&
						<Buttons
							handleClick={typeLogin ? handleSubmitPhoneNumber : null}
							textBtn={t("daily_reward.confirm")}
							classItem="!my-0"
							disabled={isLoadingBtn}
						/>
					}
					<p
						onClick={handleLoginWith}
						className='text-[15px] sm:text-[20px] font-bold text-[rgba(161,92,7,1)] italic underline cursor-pointer text-center'
					>
						{typeLogin ? t('modal.modal_login.or_login_with_OTP') : t('modal.modal_login.or_login_with_password')}
					</p>
				</div>
			</div>

		</PopupFrame>
	);
}
